import { createStage, findTemplates, type Stage } from "../../dice/stage";

const part = (name: string) => document.querySelector<HTMLElement>(`[data-dice-stage="${name}"]`);

// The dice bar's own focus rule: its ✕ while the box is open, its d20 otherwise.
export function focusRoller() {
	const roller = part("roller");
	const open = roller?.querySelector<HTMLElement>('[data-dice-roller-target="column"]')?.hidden === false;
	roller?.querySelector<HTMLElement>(`[data-dice-roller-target="${open ? "closer" : "opener"}"]`)?.focus();
}

// The page's own stage (`live_sheets/_dice_stage.html.erb`), where a roll plays as it does on the Mapas board. A page
// without the roller box gives its own place for the focus a dismissed card leaves behind.
export function pageStage(returnFocus?: () => void): Stage | null {
	const cards = part("cards");
	const announcer = part("announcer");
	const { cardTemplate, clearAllTemplate } = findTemplates(document);
	if (!cards || !announcer || !cardTemplate) return null;
	const refocus = returnFocus ?? focusRoller;
	return createStage({
		cards,
		announcer,
		layer: part("layer"),
		cardTemplate,
		clearAllTemplate,
		roller: () => part("roller"),
		refocus,
		focusDismiss: true,
		announceDetails: true,
	});
}
